import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { urlT3Record } from 'src/app/common';

@Injectable({
  providedIn: 'root'
})
export class T3RecordService {

  constructor(private http: HttpClient) { }

  get4codetest(id: string) {
    return this.http.get(`${urlT3Record}/get4code-test/${id}`);
  }

  getT3ByCodeAdm(code: string) {
    return this.http.get(`${urlT3Record}/get-all-t3-by-code/${code}`);
  }

  getSection4T3(id: number) {
    return this.http.get(`${urlT3Record}/getsection4t3/${id}`);
  }

  getSub4sec(id: string) {
    return this.http.get(`${urlT3Record}/getsubsection4sec/${id}`);
  }

  getGr4T3(id: number) {
    return this.http.get(`${urlT3Record}/getgr4t3/${id}`);
  }

  getBib4T3(id: number) {
    return this.http.get(`${urlT3Record}/getbib4t3/${id}`);
  }

  getPrim4T3(id: number) {
    return this.http.get(`${urlT3Record}/getprim4t3/${id}`);
  }

  cloneTier3(id: string) {
    return this.http.post(`${urlT3Record}/clone-tier3/${id}`, null);
  }

}
